<template>
  <div class="device-info flex-d-b-c" :key="currentDetail.id">
    <div class="d-capture flex-a-c" v-loading="!captureImg" :element-loading-text="$t('ctcdin1')">
      <el-image :src="captureImg" fit="contain" style="width: 100%; height: 100%">
        <!-- <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div> -->
        <!-- <div slot="error" style="height: 100%" class="image-slot flex-d-a-c" v-if="captureImg === 'LoadingError'">
          <span><i class="el-icon-picture-outline"></i>截图失败 ...</span>
        </div> -->
      </el-image>
    </div>
    <div class="d-info" v-loading="!captureImg" :element-loading-text="$t('ctcdin2')">
      <device-info :currentDetail="currentDetail" :deviceInfo="deviceInfo"></device-info>
    </div>
    <div class="d-control" :key="currentDetail.id">
      <device-control :currentDetail="currentDetail" :deviceInfo="deviceInfo"></device-control>
    </div>
  </div>
</template>

<script>

// import { reTimeFormatting, } from "@/assets/scripts/dateFormatting";
import DeviceControl from "./DeviceControl";
import DeviceInfo from "./DeviceInfo";
import translate from "../tools/translate.js";

export default {
  name: 'DeviceDetails',
  props: {
    currentDetail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      captureImg: "",
      deviceInfo: { ...this.currentDetail }
    }
  },
  methods: {
    initSocket() {
      this.myWebSocket.onmessage = (val) => {
        const { sn: infoSN, id } = this.currentDetail;
        const { type, data, sn } = JSON.parse(val.data);
        // console.log(pandora_id, id);
        if (infoSN != sn) { return false; }

        switch (type) {
          case "invoke_method": {
            const uri = data.uri;
            const res = JSON.parse(data.response);
            // invoke_method
            switch (uri) {
              case "device": {
                this.deviceInfo = { ...this.deviceInfo, ...res.data };
              } break;
              case "getScreenParams": {
                this.deviceInfo = { ...this.deviceInfo, ...res };
              } break;
              case "getCurTime": {
                this.deviceInfo = { ...this.deviceInfo, ...res };
              } break;
              case "getDeviceInfo": {
                let dData = {};
                res.data.split("\n").filter((v) => v).map((v) => {
                  let arr = v.split("：");
                  dData[arr[0]] = translate(arr[1],this);
                  return { [arr[0]]: arr[1] };
                });
                this.deviceInfo = { ...this.deviceInfo, ...dData };
              } break;
              case "getSignalInput": {
                this.deviceInfo = { ...this.deviceInfo, ...{ signalSourceValue: res.input } };
              } break;
              case "getCloudRebootStatus": {
                this.deviceInfo = { ...this.deviceInfo, ...{ cloudRebootStatus: res.status ? this.$t('ctcdin3') : this.$t('ctcdin4') } };
              } break;
              case "getLanguages": {
                this.deviceInfo = { ...this.deviceInfo, ...{ languages: res.data[0].zhName } };
              } break;
              case "getDeviceState": {
                this.deviceInfo = { ...this.deviceInfo, ...{ programName: res.programName } };
              } break;
              case "getSysRunningTime": {
                this.deviceInfo = { ...this.deviceInfo, ...{ runningTime: res.runningTime } };
              } break;
              case "getRunDetail": {
                this.deviceInfo = { ...this.deviceInfo, ...res };
              } break;
              default:
                break;
            }
          } break;
          case "capture": {
            this.captureImg = `/upload/capture/d_${id}/device_${id}_capture.png?t=${new Date().getTime()}`;
          } break;
          // case "get_device_info": {
          //   console.log(data.data);
          // } break;
          default:
            break;
        }
      }
    },

    invokeMethod(data, type = "set") {

      this.initSocket();

      let commands_info = [];
      if (Array.isArray(data)) {
        commands_info = data.map((data) => ({ type: "invoke_method", data }));
      } else {
        commands_info = [{ type: "invoke_method", data }];
      }

      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, () => {
        type === 'set' && this.$msg({ message: this.$t('ctcdin5'), type: "success" });
      });
    },
    getCaputer() {
      this.captureloading = true;
      const { id, sn, type_id } = this.currentDetail;
      this.$http.post("/admin/command/capture", {
        command: "capture",
        devices_info: encodeURIComponent(JSON.stringify([{ id, sn, type_id }])),
      }, () => { });
    },
    initDeviceInfo() {
      const { run_state } = this.currentDetail;
      if (run_state === 0) {
        setTimeout(() => { this.captureImg = "LoadingError"; }, 1000);
        return;
      }
      this.invokeMethod([
        { methodName: "device", methodParams: {} },
        { methodName: "getScreenParams", methodParams: {} },
        { methodName: "getCurTime", methodParams: {} },
        { methodName: "getDeviceInfo", methodParams: {} },
        { methodName: "getSignalInput", methodParams: {} },
        { methodName: "getCloudRebootStatus", methodParams: {} },
        { methodName: "getLanguages", methodParams: {} },
        { methodName: "getDeviceState", methodParams: {} },
        { methodName: "getSysRunningTime", methodParams: {} },
        { methodName: "getRunDetail", methodParams: {} },
      ], "get");
    }
  },
  mounted() {
    this.initSocket();
    this.getCaputer();
    this.initDeviceInfo();
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  components: {
    DeviceControl,
    DeviceInfo
  }
}
</script>

<style lang="scss" scoped>
.device-info {
  min-width: 240px;
  height: calc(100% - 8px);
  padding: 4px;

  .d-capture {
    width: 100%;
    height: 136px;
    // overflow: hidden;
    background: #000;
  }

  .d-info {
    width: 100%;
    height: calc(100% - 140px - 80px - 20px);
    background: #f5f7fa;
    overflow-y: auto;
  }

  .d-control {
    width: 100%;
    height: 80px;
    background: #f5f7fa;
  }
}
</style>